import React from 'react'
import { injectIntl } from 'react-intl'

import HeaderIndicatorsContainer from 'modules/Indicators/Header/HeaderIndicatorsContainer'
import RegionTools from 'utils/regions/regionTools'
import APPURL from 'utils/app/urls'
import messages from './messages'

const RegionOverview = props => {
  const {
    intl: { formatMessage }
  } = props

  this.formatMessage = formatMessage

  // const language = props.match.params.lang;
  let selectedRegionName = ''
  if (props.regionsData) {
    selectedRegionName = RegionTools.getRegionNameFromId({ regionsData: props.regionsData, id: props.selectedRegionId })
  }
  // let button;

  // let regionMeta = Config.getConfig().region_meta;
  // if ( regionMeta.hasOwnProperty( String( props.selectedRegionId ) ) ) {
  //   let altview = Config.getConfig().region_meta[ String( props.selectedRegionId ) ][ "altview" ]; 
  //   let alturl = altview.url.replace('{language}', language);
  //   button = <a className="btn btn-sm btn-primary btn-reg-altview" href={alturl} style={{float: "right"}} role="button">{this.formatMessage(messages[altview.msgid])}</a>;
  // }

  let reportPanelBanner = null;
  if (props.selectedRegionId === 1) {
    const path = props.history.location.pathname;
    const reportPanelLink = APPURL.getReportPanelLink(path);
    reportPanelBanner = <React.Fragment>
      <div className='alert-new' dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.alertNewReportPanel, { reportPanelLink })}}></div>
    </React.Fragment>
  }

  return (
    <React.Fragment>
      <div>
        <h1 style={{display: "inline"}}>{selectedRegionName}</h1>
        {/* {button} */}
      </div>
      <div className="ork-region-overview">
        <HeaderIndicatorsContainer />
      </div>
      {reportPanelBanner}
    </React.Fragment>
  )
}
export default injectIntl(RegionOverview)



// WEBPACK FOOTER //
// ./src/components/RegionOverview/RegionOverview.js